export enum RateTerms {
  FIOS = 'FIOS',
  LINER = 'LINER',
  FILO = 'FILO',
  LIFO = 'LIFO'
}
